import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=20b9c1ac&"
import script from "./VerifyEmail.vue?vue&type=script&lang=ts&"
export * from "./VerifyEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports